module.exports = __webpack_public_path__ + "media/images/powered-5bd5bc0f.png";